import React, { useRef } from "react";
import { useLocaleContext } from "../../../context/LocaleContext";
import { getAbsoluteTimeByPlayerTime, getHumanDuration, rangeLimit } from "../../../../../common/src";
import { getStreamSessions } from "../../../../../common/src/stream";
import "./style.scss";

export default ({ position, duration, width, stream, streamEpisodes, streamDay, offsetLeft = 0, timeOffset = 0 }) => {
    const { getProperty } = useLocaleContext();
    const hintRef = useRef(null);
    const className = 'stream-player-progressBar';

    if (!duration || null === position) {
        return null;
    }

    const hintWidth = hintRef.current?.offsetWidth || 0;
    const positionLeft = rangeLimit(position * width - hintWidth / 2, 0, width - hintWidth) + offsetLeft + 'px';
    const positionTime = position * duration;
    const sessions = getStreamSessions(stream);
    const positionAbsoluteTime = getAbsoluteTimeByPlayerTime(positionTime, streamDay, sessions, stream.timeStart, stream.timeStop);

    let episode = null;
    if (streamEpisodes?.length > 0) {
        episode = streamEpisodes.find((episode) => (
            (episode.timeStart - timeOffset) < positionAbsoluteTime && (episode.timeStop - timeOffset) > positionAbsoluteTime
        ));
    }

    return (
        <div className={`${className}-hint` + (episode ? ` ${className}-hint-withEpisode` : '')} ref={hintRef} style={{ left: positionLeft }}>
            {episode
                ? <div>
                    {episode.preview && (
                        <div
                            className={`${className}-hint-episode-preview`}
                            style={{ backgroundImage: `url(${episode.preview})` }}
                            title={getProperty(episode, 'name')}
                        />
                    )}
                    <div className={`${className}-hint-description`}>
                        <div className={`${className}-hint-episode-title`}>{getProperty(episode, 'name')}</div>
                        <div className={`${className}-hint-time`}>{getHumanDuration(position * duration, true)}</div>
                    </div>
                </div>
                : <div>
                    <div>
                        <div className={`${className}-hint-time`}>{getHumanDuration(position * duration, true)}</div>
                    </div>
                </div>
            }
        </div>
    );
}
